var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.9,
    height: 167.397,
    viewBox: "0 0 160.9 167.397",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_5",
    "data-name": "Union 5",
    d: "M118.933,167.2a1.993,1.993,0,0,1-1.133-1.8V145H0V0H22V123h95.8V103a2,2,0,0,1,3.246-1.563l39.1,31.188a2,2,0,0,1,0,3.128l-39.1,31.206a2,2,0,0,1-1.248.438A1.974,1.974,0,0,1,118.933,167.2Z",
    fill: "#344d99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentReply);
export default __webpack_public_path__ + "static/media/commentReply.5bc7fb7bd0d1b872bc75326ec6c4b775.svg";
export { ForwardRef as ReactComponent };